module.exports = __webpack_public_path__ + "01_long_gray.32304215.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_long_gray.png
// module id = Xzhv
// module chunks = 0